export default "https://d1e6s5z4lzmgxx.cloudfront.net/e6c6b85e-6085-403a-93bd-a279ec1d3907/images/ob-step-11.png?eb047bdf912107b40599bfe8bbddf7ab";